import Card from 'react-bootstrap/Card';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';

const PreIntermediatePayment = () => {
  return (
    <div>
      <h2 className="subheading text-center animation">Оплатить курс English for Amateurs</h2>
      <div className="d-flex justify-content-around mb-5 mt-3 payment-div">
        <div className="payment-card">
          <Card className="text-center h-100">
            <Card.Header className="tariff">Тариф All by myself</Card.Header>
            <Card.Body>
              <Card.Title className="subsubheading">Что входит в курс:</Card.Title>
              <Card.Text>
                15 модулей, каждый из которых включает:
                <li>ВИДЕО объяснения (на русском)</li>
                <li>ПРЕЗЕНТАЦИИ (in English с переводом)</li>
                <li>АУДИО для развития навыка аудирования (in English)</li>
                <li>ТЕКСТЫ для чтения (in English)</li>
                <li>Задания на ПИСЬМО (in English)</li>
                <li>СПИСОК СЛОВ для запоминания (in English)</li>
                <li>ТЕСТЫ на проверку понимания</li>
                <li>ЧАТ с одногруппниками в Telegram</li>
                {/* <span className='d-flex flex-column fw-bold fs-4'>
                  <span className='navi-tabs'>Стоимость:</span>
                  <span className='text-danger'>$110</span>
                  <span className='text-danger'>₽8.700</span>
                </span> */}
              </Card.Text>
              {/* <Tabs defaultActiveKey="card" id="pre-intermediate-payment-tab-1" className="my-4" justify>
                <Tab eventKey="card" title="Картой">
                  <a className="button" href="" role="button" target="_blank">Оплата картой</a>
                  <h6 className="text-danger m-3">
                    Оплата не пройдёт с карт, выпущенных в России и Украине.
                    <br></br><br></br>
                    Пишите мне на <span className='email'>ElenaAndEnglish@gmail.com</span>, если у вас сложности с оплатой.
                    <br></br><br></br>
                    Доступ к курсу будет выслан на <u>имейл</u>, указанный при оплате.
                  </h6>
                </Tab>
                <Tab eventKey="zelle" title="Zelle">
                  <h6 className='email'>ElenaAndEnglish@gmail.com</h6>
                  <p className="text-danger">Данный способ доступен только тем, кто живёт в США. Пожалуйста, укажите свой <u>имэйл</u> в поле 'Memo', иначе я не узнаю, кому и куда выслать доступ к курсу (либо напишите мне имейл или в личку)</p>
                  <a href="https://www.zellepay.com/" target="_blank">Как оплатить через Zelle</a>
                </Tab>
                <Tab eventKey="yoomoney" title="YooMoney (Yandex)">
                  <a className="button" href="" role="button" target="_blank">YooMoney (Yandex)</a>
                  <p className="text-danger mt-4">Если вы платите через YooMoney, пожалуйста, скиньте мне в личку или на почту <span className='email'>ElenaAndEnglish@gmail.com</span> скрин платежа (и ваш имэйл), иначе я не узнаю, кому и куда выслать доступ к курсу</p>
                </Tab>
              </Tabs> */}
            </Card.Body>
            <Card.Footer className="text-muted mt-2">Для тех, кто любит учиться самостоятельно</Card.Footer>
          </Card>
        </div>
        <div className="payment-card">
        <Card className="text-center h-100">
            <Card.Header className="tariff">Тариф Check me out</Card.Header>
            <Card.Body>
              <Card.Title className="subsubheading">Что входит в курс:</Card.Title>
              <Card.Text>
                15 модулей, каждый из которых включает:
                <li>ВИДЕО объяснения (на русском)</li>
                <li>ПРЕЗЕНТАЦИИ (in English с переводом)</li>
                <li>АУДИО для развития навыка аудирования (in English)</li>
                <li>ТЕКСТЫ для чтения (in English)</li>
                <li>Задания на ПИСЬМО (in English)</li>
                <li>СПИСОК СЛОВ для запоминания (in English)</li>
                <li>ТЕСТЫ на проверку понимания</li>
                <li>ЧАТ с одногруппниками в Telegram</li>
                +
                <li className='accent'>Еженедельные ВЕБИНАРЫ с Еленой (всего - 8)</li>
                <li className='accent'>1-на-1 СОЗВОН с Еленой (2 раза в неделю, всего - 14)</li>
                <li className='accent'>1-на-1 финальный СОЗВОН с американцем Грэгом (1 раз, 30 минут)</li>
                {/* <span className='accent'>--------------------</span>
                <span className='d-flex flex-column fw-bold fs-4'>
                  <span className='navi-tabs'>Стоимость:</span>
                  <span className='text-danger'>TBD (будет уточнена позже)</span>
                </span> */}
              </Card.Text>
              {/* <Tabs defaultActiveKey="card" id="pre-intermediate-payment-tab-2" className="my-4" justify>
                <Tab eventKey="card" title="Картой">
                  <a className="button" href="" role="button" target="_blank">Оплата картой</a>
                  <h6 className="text-danger m-3">
                    Оплата не пройдёт с карт, выпущенных в России и Украине.
                    <br></br><br></br>
                    Пишите мне на <span className='email'>ElenaAndEnglish@gmail.com</span>, если у вас сложности с оплатой.
                    <br></br><br></br>
                    Доступ к курсу будет выслан на <u>имейл</u>, указанный при оплате.
                  </h6>
                </Tab>
                <Tab eventKey="zelle" title="Zelle">
                  <h6 className='email'>ElenaAndEnglish@gmail.com</h6>
                  <p className="text-danger">Данный способ доступен только тем, кто живёт в США. Пожалуйста, укажите свой <u>имэйл</u> в поле 'Memo', иначе я не узнаю, кому и куда выслать доступ к курсу (либо напишите мне имейл или в личку)</p>
                  <a href="https://www.zellepay.com/" target="_blank">Как оплатить через Zelle</a>
                </Tab>
                <Tab eventKey="yoomoney" title="YooMoney (Yandex)">
                  <a className="button" href="" role="button" target="_blank">YooMoney (Yandex)</a>
                  <p className="text-danger mt-4">Если вы платите через YooMoney, пожалуйста, скиньте мне в личку или на почту <span className='email'>ElenaAndEnglish@gmail.com</span> скрин платежа (и ваш имэйл), иначе я не узнаю, кому и куда выслать доступ к курсу</p>
                </Tab>
              </Tabs> */}
            </Card.Body>
            <Card.Footer className="text-muted mt-2">Для тех, кто хочет учиться под контролем преподавателя</Card.Footer>
          </Card>
        </div>
      </div>
    </div>
  )
};

export default PreIntermediatePayment;